import React from 'react';
import Utils from '../providers/Utils';
import { Fab, Button, Hidden, Divider, Avatar, Menu, MenuItem, IconButton, Grid } from '@material-ui/core';
import PropTypes from 'prop-types'
import TaskMenu from '../commons/TaskMenu'
import Ws from '../providers/Ws';
import ChangeEtapaViewMenu from './ChangeEtapaViewMenu';
import TabelTask from './TabelTask';
import SpecificComponent from './SpecificComponent';



export default class GanttEtapeMonthView extends SpecificComponent {
    constructor(props) {
        super(props);

        this.state = {
            slideValue: 0,
            taskToChangeDate: {},
            whatChange: false,
            openMenu: false
        }
    }

    componentDidMount() {


    }


    dragStart = (t) =>{
        console.log('t :>> ', t);
    }

    taskData = {}
    elData = {}

    ws = new Ws()



    callBack = (c) => {
        // console.log('c.value :>> ', c);

        if (c.id === 1) {
            this.props.editTask(c.task, this.props.objEtapaSelectata)
        } else {
            this.props.showChangeArrow(c.task)
        }
    }


    changeViewOption = (tip) => {
        this.props.changeViewOption(tip)
    }

    changeDate = async (t) => {
        // console.log('task to change date :>> ', t);
        // console.log('objEtapaSelectata :>> ', this.props.objEtapaSelectata);

        let task = t

        if(new Date(new Utils().ParseDataFromSql(task.cand_data)) <= new Date(this.props.objEtapaSelectata.durata_de_la) ){
            task.cand_data = this.props.objEtapaSelectata.durata_de_la
        }

        if(new Date(new Utils().ParseDataFromSql(task.pana_cand_data)) >= new Date(this.props.objEtapaSelectata.durata_pana_la)){
            task.pana_cand_data =  this.props.objEtapaSelectata.durata_pana_la
        }

        let candDataTask = new Date(new Utils().ParseDataFromSql(task.cand_data))
        let dataTask = new Date(new Utils().ParseDataFromSql(task.pana_cand_data))

        let dataEtapa = new Date(this.props.objEtapaSelectata.durata_pana_la)

        dataTask = dataTask.setDate(dataTask.getDate())


        dataTask = new Date(dataTask)

        let dateToUpdate = new Utils().transformDataForSql(dataTask)

        // console.log('dataTask :>> ', dateToUpdate);

        task.pana_cand_data = dateToUpdate + 'T00:00:00'



        if (dataTask > dataEtapa) {
            // console.log('no puedo :>> ');
        } else {

            if (dataTask < candDataTask) {

            } else {
                let update = await this.ws.update('taskuri', { pana_cand_data: dateToUpdate }, { id: t.id })

                // console.log('update :>> ', update);

                if (update.Succes) {
                    this.props.updateTasks(task)
                }
            }


        }
    }

    changeCandData = async (t) => {
        let task = t

        if(new Date(new Utils().ParseDataFromSql(task.cand_data)) <= new Date(this.props.objEtapaSelectata.durata_de_la) ){
            task.cand_data = this.props.objEtapaSelectata.durata_de_la
        }

        if(new Date(new Utils().ParseDataFromSql(task.pana_cand_data)) >= new Date(this.props.objEtapaSelectata.durata_pana_la)){
            task.pana_cand_data =  this.props.objEtapaSelectata.durata_pana_la
        }

        let candDataTask = new Date(new Utils().ParseDataFromSql(task.cand_data))
        let panaCandDataTask = new Date(new Utils().ParseDataFromSql(task.pana_cand_data))


        let dataEtapa = new Date(this.props.objEtapaSelectata.durata_de_la)

        candDataTask = candDataTask.setDate(candDataTask.getDate())

        candDataTask = new Date(candDataTask)

        let dateToUpdate = new Utils().transformDataForSql(candDataTask)

        task.cand_data = dateToUpdate + 'T00:00:00'


        console.log('task data update :>> ', task);
        if (candDataTask < dataEtapa) {


        } else {

            if(candDataTask > panaCandDataTask){

            }else{
                let update = await this.ws.update('taskuri', { cand_data: dateToUpdate }, { id: t.id })

                if (update.Succes) {
                    this.props.updateTasks(task)
                }
            }
            
        }
    }

    removeEventMouseDown = () => {

        document.getElementById('etapaID').removeEventListener('mousemove', this.mousePosition, true)



        this.changeDate(this.taskData)

        console.log('this.taskData :>> ', this.taskData);
    }

    removeEventMouseDownLeft = () => {



        document.getElementById('etapaID').removeEventListener('mousemove', this.mousePositionLeft, true)

        this.changeCandData(this.taskData)

        console.log('this.taskDataMouse down left remove :>> ', this.taskData);
    }

    changeSizeLeft = (t, id, idD) => {
        let el = document.getElementById(id)

        this.taskData = t
        this.elData = el

        document.getElementById('etapaID').addEventListener('mousemove', this.mousePositionLeft, true)

        document.getElementById('etapaID').addEventListener('mouseup', this.removeEventMouseDownLeft, true)


    }

    changeSize = (t, id, idD) => {

        let el = document.getElementById(id)

        console.log('el :>> ', el);

        this.taskData = t
        this.elData = el


        document.getElementById('etapaID').addEventListener('mousemove', this.mousePosition, true)

        // document.getElementById('etapaID').removeEventListener('mousemove' , this.mousePosition, true)

        document.getElementById('etapaID').addEventListener('mouseup', this.removeEventMouseDown, true)
        // let elSize = el.getBoundingClientRect()

        // console.log('elSize :>> ', elSize);
    }

    mousePositionLeft = (e) => {

        console.log('e :>> ', e);
        let panaCandData = { ...this.taskData.pana_cand_data }

        let task = { ...this.taskData }

        let el = this.elData

        let dataStart = new Date(this.props.objEtapaSelectata.durata_de_la)
        let dataFinish = new Date(this.props.objEtapaSelectata.durata_pana_la)

        let timeDiff = Math.abs(dataFinish.getTime() - dataStart.getTime());

        let dayDifference = Math.ceil(timeDiff / (1000 * 3600 * 24));
        let dateList = Math.ceil(dayDifference / this.props.screenLimit)

        console.log('dateList :>> ', dateList);

        let elContainer = document.getElementById('etapaID')

        let elContainerWidth = elContainer.getBoundingClientRect().width

        let elContainerLeft = elContainer.getBoundingClientRect().left

        // console.log('elContainerWidth :>> ', elContainer.getBoundingClientRect());

        let tenP = elContainerWidth * (10 + dateList) / 100

        // console.log('tenP :>> ', tenP);



        var posX = e.clientX
        var posY = e.clientY

        let elSize = el.getBoundingClientRect()

        // console.log('posX :>> ', posX);

        // console.log('elSize :>> ', elSize);

        if (elSize.left - tenP > posX) {

            // console.warn('elSizeLeft = tenP :>> ', elSize.left - tenP);

            el.style.marginLeft = (elSize.left - tenP - elContainerLeft) * 100 / elContainerWidth + '%'
            if ((elSize.left - elContainerLeft) > 1) {
                el.style.width = ((elSize.right - elSize.left + tenP)) * 100 / elContainerWidth + '%'
            } else {
                console.warn('enter here ')
                el.style.width = ((elSize.right - elSize.left + tenP)) * 100 / elContainerWidth + '%'
            }

            let dataTask = new Date(new Utils().ParseDataFromSql(task.cand_data))

            dataTask = dataTask.setDate(dataTask.getDate() - dateList)

            dataTask = new Date(dataTask)


            let dateToUpdate = new Utils().transformDataForSql(dataTask)
            task.cand_data = dateToUpdate + 'T00:00:00'

            this.taskData = task

            console.log('task :>> ', task);


            // console.log('el.style.marginLeft :>> ', el.style.marginLeft);
            // console.log('el :>> ', el.getBoundingClientRect());
        } else if (elSize.left < (posX - tenP)) {

            let right = elSize.right

            console.log('right :>> ', right);
            console.log('elSize :>> ', elSize);

            // el.style.marginLeft = (elSize.left + tenP - elContainerLeft) * 100 / elContainerWidth + '%'
            console.log('right - elSize.width + elSize.left :>> ', right - posX);



            if ((right - posX) <= 150) {

            } else {
                el.style.marginLeft = (elSize.left + tenP - elContainerLeft) * 100 / elContainerWidth + '%'
                el.style.width = (right - posX) * 100 / elContainerWidth + '%'


            }


            let dataTask = new Date(new Utils().ParseDataFromSql(task.cand_data))
            let dataTaskFinish = new Date(new Utils().ParseDataFromSql(task.pana_cand_data))

            let dataTaskToUpdate = dataTask.setDate(dataTask.getDate() + dateList)

            dataTaskToUpdate = new Date(dataTask)

            const diffTime = Math.abs(dataTaskFinish - dataTaskToUpdate);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

            console.log('diffDays :>> ', diffDays);

            if (diffDays >= dateList) {
                task.cand_data = new Utils().transformDataForSql(dataTaskToUpdate) + 'T00:00:00'

                this.taskData = task
            }

            console.log('task :>> ', task);


            // if(elSize.width < 150 ){

            // }
        }



        console.log('task :>> ', task);

        if(new Date(new Utils().ParseDataFromSql(task.cand_data)) <= new Date(this.props.objEtapaSelectata.durata_de_la) ){
            this.taskData.cand_data = this.props.objEtapaSelectata.durata_de_la
        }

        if(new Date(new Utils().ParseDataFromSql(task.pana_cand_data)) >= new Date(this.props.objEtapaSelectata.durata_pana_la)){
            this.taskData.pana_cand_data =  this.props.objEtapaSelectata.durata_pana_la
        }

    }






    mousePosition = (e) => {

        let candData = { ...this.taskData.cand_data }

        let task = { ...this.taskData }

        let el = this.elData


        let dataStart = new Date(this.props.objEtapaSelectata.durata_de_la)

        let dataFinish = new Date(this.props.objEtapaSelectata.durata_pana_la)


        let timeDiff = Math.abs(dataFinish.getTime() - dataStart.getTime());

        let dayDifference = Math.ceil(timeDiff / (1000 * 3600 * 24));
        let dateList = Math.ceil(dayDifference / this.props.screenLimit)

        console.log('dayDifference :>> ', dateList);

        let elContainer = document.getElementById('etapaID')

        let elContainerWidth = elContainer.getBoundingClientRect().width


        let tenP = elContainerWidth * 10 / 100

        var posX = e.clientX;
        var posY = e.clientY;

        let elSize = el.getBoundingClientRect()


        if (elSize.right + tenP < posX) {
            console.log('elSize more :>> ', elSize);
            console.log('el :>> ', el);


            el.style.width = (elSize.width + tenP) * 100 / elContainerWidth + '%'
            el.style.maxWidth = elContainerWidth - 20 + 'px'

            console.log('el.style.width :>> ', el.style.width);
            let dataTask = new Date(new Utils().ParseDataFromSql(task.pana_cand_data))

            dataTask = dataTask.setDate(dataTask.getDate() + dateList)


            dataTask = new Date(dataTask)

            let dateToUpdate = new Utils().transformDataForSql(dataTask)
            task.pana_cand_data = dateToUpdate + 'T00:00:00'



            this.taskData = task


        }
        else if (elSize.right > (posX + tenP)) {



            el.style.width = (elSize.width - tenP) * 100 / elContainerWidth + '%'

            let dataTask = new Date(new Utils().ParseDataFromSql(task.pana_cand_data))

            dataTask = dataTask.setDate(dataTask.getDate() - dateList)


            dataTask = new Date(dataTask)

            let dateToUpdate = new Utils().transformDataForSql(dataTask)
            task.pana_cand_data = dateToUpdate + 'T00:00:00'




            this.taskData = task



            if (elSize.width < 150) {
                el.style.width = 150 + 'px'

                task.pana_cand_data = candData

                this.taskData = task


            }
        }

      


        //    console.log('posX :>> ', posX);
        //    console.log('posY :>> ', posY);
    }


    showEdit = (t) => {



        let el = document.getElementById(t)

        el.style.display = 'block'

        setTimeout(() => {
            el.style.display = 'none'
        }, 5000)


    }

    numeAvatar = (nume) => {

        if(nume){
            let n = nume.split(' ')

            // console.log('n :>> ', n);
    
            let firstLetters = ''
    
            if (n[0]) {
    
                firstLetters += n[0].substring(0, 1)
    
            }
            if (n[1]) {
                firstLetters += n[1].substring(0, 1)
            }
    
            firstLetters = firstLetters.toUpperCase()
    
            return firstLetters
        }else{
            return 'NA'
        }
        

    }

    showAvatar = (t) => {


        if (t.utilizator_responsabil.length > 0) {
            if (t.utilizator_responsabil[0].poza) {
                return (



                    <Avatar
                        onMouseEnter={() => { this.props.showUserTag(t) }}
                        onMouseLeave={() => { this.props.hideUserTag(t) }}
                        style={{ display: 'inline-block', marginLeft: 10, width: 36, height: 36, marginTop: 2 }} src={this.ws.adresaMedia + '/Angajati/' + t.utilizator_responsabil[0].poza} />

                )
            } else {


                return (

                    <Avatar
                        onMouseEnter={() => { this.props.showUserTag(t) }}
                        onMouseLeave={() => { this.props.hideUserTag(t) }}
                        style={{ display: 'inline-block', width: 36, height: 36, textAlign: 'center', marginLeft: 10, marginTop: 2, backgroundColor: new Utils().culoriUtilizatori(t.utilizator_responsabil[0].id) }}>
                        {/* <i style={{ verticalAlign: '-webkit-baseline-middle' }} className='material-icons'>person</i> */}
                        <span style={{marginTop:'20%', display:'block'}}>{this.numeAvatar(t.utilizator_responsabil[0].nume)} </span>
                    </Avatar>

                )

            }
        } else {
            return ''
        }


    }






    arataData = (d) => {

        let u = new Utils();

        if (this.props.dictionary.date === 'en') {
            return u.dataPrescurtataEngNoYear(u.ParseDataFromSql(d))
        } else {
            return u.dataPrescurtataRomanaNoYear(u.ParseDataFromSql(d))
        }


    }

    hideSlider = (ev) => {
        if (this.state.whatChange) {
            let objEtapaInfo = this.props.objEtapaSelectata
            let dataStart = new Date(objEtapaInfo.durata_de_la)
            let dataChange = new Date(this.state.taskToChangeDate.pana_cand_data)


            let dataFinish = new Date(objEtapaInfo.durata_pana_la)


            let timeDiff = Math.abs(dataFinish.getTime() - dataStart.getTime());

            let timeDiffTask = Math.abs(dataChange.getTime() - dataStart.getTime());

            let dayDifference = Math.ceil(timeDiff / (1000 * 3600 * 24));

            let dayDifferenceT = Math.ceil(timeDiffTask / (1000 * 3600 * 24));

            let dateList = Math.ceil(dayDifference / this.props.screenLimit)

            let counter = Math.floor(dayDifferenceT / dateList)

            // console.warn('counter :', counter);

            // console.warn('date list', dateList)

            // console.warn('ev.target.value :', ev.target.value);

            if (ev.target.value > counter) {
                let dif = ev.target.value - counter

                dataChange = dataChange.setDate(dataChange.getDate() + (dif * dateList))

            } else {
                let dif = counter - ev.target.value
                dataChange = dataChange.setDate(dataChange.getDate() - (dif * dateList))
            }

            // console.warn('dataFinish :', new Date(dataChange));
            this.setState({ slideValue: ev.target.value }, async () => {
                await this.props.changePanaCandData(new Date(dataChange))
            })


        } else {
            let objEtapaInfo = this.props.objEtapaSelectata
            let dataStart = new Date(objEtapaInfo.durata_de_la)
            let dataFinish = new Date(objEtapaInfo.durata_pana_la)
            let dataChange = new Date(this.state.taskToChangeDate.cand_data)

            let timeDiff = Math.abs(dataFinish.getTime() - dataStart.getTime());

            let timeDiffTask = Math.abs(dataChange.getTime() - dataStart.getTime());

            let dayDifference = Math.ceil(timeDiff / (1000 * 3600 * 24));

            let dayDifferenceT = Math.ceil(timeDiffTask / (1000 * 3600 * 24));

            let dateList = Math.ceil(dayDifference / this.props.screenLimit)

            let counter = Math.floor(dayDifferenceT / dateList)

            // console.warn('counter :', counter);

            // console.warn('date list', dateList)

            // console.warn('ev.target.value :', ev.target.value);

            if (ev.target.value > counter) {
                let dif = ev.target.value - counter

                dataChange = dataChange.setDate(dataChange.getDate() + (dif * dateList))

            } else {
                let dif = counter - ev.target.value
                dataChange = dataChange.setDate(dataChange.getDate() - (dif * dateList))
            }

            // console.warn('dataFinish :', new Date(dataChange));
            this.setState({ slideValue: ev.target.value }, async () => {
                await this.props.changeCandData(new Date(dataChange))
            })
        }

        let slider = document.getElementById(ev.target.id)

        slider.style.display = 'none'
    }

    changeSlideVal = async (ev) => {
        this.setState({ slideValue: ev.target.value })
    }

    // openSlide = (t, careData, sId, objEtapa) => {
    //     if (careData === 'pana_cand_data') {

    //         let objEtapaInfo = this.props.objEtapaSelectata

    //         console.warn('objEtapaInfo :>> ', objEtapaInfo);



    //         let dataStart = new Date(objEtapaInfo.durata_de_la)
    //         let dataFinish = new Date(t.pana_cand_data)

    //         let timeDiff = Math.abs(dataFinish.getTime() - dataStart.getTime());

    //         let dayDifference = Math.ceil(timeDiff / (1000 * 3600 * 24));
    //         // console.warn('dayDifference :', dayDifference);

    //         let timeDiffE = Math.abs(new Date(objEtapaInfo.durata_de_la).getTime() - new Date(objEtapaInfo.durata_pana_la).getTime());

    //         let dayDifferenceE = Math.ceil(timeDiffE / (1000 * 3600 * 24));

    //         let dateList = Math.ceil(dayDifferenceE / this.props.screenLimit)

    //         // console.warn('dateList :', dateList);

    //         let counter = Math.floor(dayDifference / dateList)

    //         // console.warn('counter :', counter);

    //         let slider = document.getElementById(sId)

    //         slider.style.display = 'block'
    //         slider.style.bottom = (t.bottom - 20) + 'px'



    //         this.setState({
    //             slideValue: counter,
    //             whatChange: true,
    //             taskToChangeDate: t
    //         }, () => {
    //             this.props.editTask(t, objEtapa, true)
    //         })
    //     } else {
    //         let objEtapaInfo = this.props.objEtapaSelectata
    //         let dataStart = new Date(objEtapaInfo.durata_de_la)
    //         let dataFinish = new Date(t.cand_data)

    //         let timeDiff = Math.abs(dataFinish.getTime() - dataStart.getTime());

    //         let dayDifference = Math.ceil(timeDiff / (1000 * 3600 * 24));


    //         let timeDiffE = Math.abs(new Date(objEtapaInfo.durata_de_la).getTime() - new Date(objEtapaInfo.durata_pana_la).getTime());

    //         let dayDifferenceE = Math.ceil(timeDiffE / (1000 * 3600 * 24));

    //         let dateList = Math.ceil(dayDifferenceE / this.props.screenLimit)




    //         let counter = Math.floor(dayDifference / dateList)

    //         // console.log('counter :', counter);

    //         let slider = document.getElementById(sId)

    //         slider.style.display = 'block'
    //         slider.style.bottom = (t.bottom - 20) + 'px'



    //         this.setState({
    //             slideValue: counter,
    //             whatChange: false,
    //             taskToChangeDate: t
    //         }, () => {
    //             this.props.editTask(t, objEtapa, true)
    //         })
    //     }
    // }



    listHead = () => {
        let u = new Utils();

        let objEtapaInfo = this.props.objEtapaSelectata


        console.warn('objEtapaInfo :>> ', objEtapaInfo);

        let dataStart = new Date(objEtapaInfo.durata_de_la)

        let dataStart2 = new Date(objEtapaInfo.durata_de_la)

        let dataFinish = new Date(objEtapaInfo.durata_pana_la)


        let timeDiff = Math.abs(dataFinish.getTime() - dataStart.getTime());

        let dayDifference = Math.ceil(timeDiff / (1000 * 3600 * 24));

        let today = new Date()
        today = today.setHours(0)
        today = new Date(today).setMinutes(0)
        today = new Date(today).setSeconds(0)
        today = new Date(today).setMilliseconds(0)
        today = new Date(today)


        let dateList = Math.ceil(dayDifference / this.props.screenLimit)

        let counter = Math.floor(dayDifference / dateList)



        let head = []

        if (this.props.dictionary.date === 'en') {
            for (let i = 0; i <= counter; i++) {
                let listedDate;
                let listedDate2;


                if (i === 0) {
                    listedDate = dataStart.setDate(dataStart.getDate() + i)
                    listedDate2 = dataStart2.setDate(dataStart.getDate() + dateList)
                }
                else {
                    listedDate = dataStart.setDate(dataStart.getDate() + dateList)
                    listedDate2 = dataStart2.setDate(dataStart.getDate() + dateList)
                }

                let newDate = new Date(listedDate)

                // console.log('newDate :', newDate);

                newDate = newDate.setHours(0)
                newDate = new Date(newDate).setMinutes(0)
                newDate = new Date(newDate).setSeconds(0)
                newDate = new Date(newDate).setMilliseconds(0)
                newDate = new Date(newDate)

                let newDate2 = new Date(listedDate2)
                newDate2 = newDate2.setHours(0)
                newDate2 = new Date(newDate2).setMinutes(0)
                newDate2 = new Date(newDate2).setSeconds(0)
                newDate2 = new Date(newDate2).setMilliseconds(0)
                newDate2 = new Date(newDate2)

                let dateBackground = 'transparent'
                let dateTextColor = '#7f7a7a'

                if (i % 2 === 1) {
                    dateBackground = '#eff0f1'
                }

                // if (today >= newDate && today <= newDate2) {

                //     // console.log('today--------- :', today);
                //     listedDate = today
                //     dateBackground = '#65cc5e'
                //     dateTextColor = 'white'
                // }


                if (i === counter) {

                    head.push(<div style={{ color: 'black', textAlign: 'right' }} className='pm-proiect-integral-date-head' key={`headData${i}`}>{u.dataPrescurtataEng(dataFinish)}</div>)

                } else {

                    if (i === 0) {
                        head.push(<div style={{ color: 'black', textAlign: 'left' }} className='pm-proiect-integral-date-head' key={`headData${i}`}>{u.dataPrescurtataEng(listedDate)}</div>)

                    } else {

                        head.push(<div style={{ color: 'black' }} className='pm-proiect-integral-date-head' key={`headData${i}`}>{u.dataPrescurtataEngNoYear(listedDate)}</div>)
                    }

                }
            }
        } else {
            for (let i = 0; i <= counter; i++) {
                let listedDate;
                let listedDate2;


                if (i === 0) {
                    listedDate = dataStart.setDate(dataStart.getDate() + i)
                    listedDate2 = dataStart2.setDate(dataStart.getDate() + dateList)
                } else {
                    listedDate = dataStart.setDate(dataStart.getDate() + dateList)
                    listedDate2 = dataStart2.setDate(dataStart.getDate() + dateList)
                }
                let newDate = new Date(listedDate)

                newDate = newDate.setHours(0)
                newDate = new Date(newDate).setMinutes(0)
                newDate = new Date(newDate).setSeconds(0)
                newDate = new Date(newDate).setMilliseconds(0)
                newDate = new Date(newDate)

                let newDate2 = new Date(listedDate2)
                newDate2 = newDate2.setHours(0)
                newDate2 = new Date(newDate2).setMinutes(0)
                newDate2 = new Date(newDate2).setSeconds(0)
                newDate2 = new Date(newDate2).setMilliseconds(0)
                newDate2 = new Date(newDate2)
                // console.log('newDate :', newDate);
                // console.log('new Date(listedDate2) :', new Date(listedDate2));
                let dateBackground = 'transparent'
                let dateTextColor = '#7f7a7a'

                if (i % 2 === 1) {
                    dateBackground = '#eff0f1'
                }

                // if (today >= newDate && today < newDate2) {

                //     // console.log('today--------- :', today);
                //     listedDate = today
                //     dateBackground = '#65cc5e'
                //     dateTextColor = 'white'



                // }




                if (i === counter) {
                    // console.log(' level 1 -----------:');

                    // console.log('level2 :');
                    head.push(<div style={{ color: 'black', textAlign: 'right' }} className='pm-proiect-integral-date-head' key={`headData${i + 1}`}>{u.dataPrescurtataRomana(dataFinish)}</div>)



                } else {

                    if (i === 0) {

                        head.push(<div style={{ color: 'black', textAlign: 'left' }} className='pm-proiect-integral-date-head' key={`headData${i}`}>{u.dataPrescurtataRomana(listedDate)}</div>)
                    } else {
                        head.push(<div style={{ color: 'black' }} className='pm-proiect-integral-date-head' key={`headData${i}`}>{u.dataPrescurtataRomanaNoYear(listedDate)}</div>)

                    }

                }
            }
        }

        return <div style={{ display: 'table', width: '100%' }}>
            {head}
        </div>
    }


    listBody = () => {

        let u = new Utils();

        let objEtapa = this.props.objEtapaSelectata
        let listTaskuri = this.props.listTaskuri



        let taskuriFilter = listTaskuri.filter(t => t.id_etapa_proiect === objEtapa.id)

        taskuriFilter = taskuriFilter.filter(t => (new Date(u.ParseDataFromSql(t.cand_data)) < new Date(objEtapa.durata_pana_la) && new Date(u.ParseDataFromSql(t.pana_cand_data)) <= new Date(objEtapa.durata_pana_la)))




        let dataStart = new Date(objEtapa.durata_de_la)
        let dataFinish = new Date(objEtapa.durata_pana_la)


        let timeDiff = Math.abs(dataFinish.getTime() - dataStart.getTime());

        let dayDifference = Math.ceil(timeDiff / (1000 * 3600 * 24));

        let dateList = Math.ceil(dayDifference / this.props.screenLimit)

        // console.warn('dateList :', dateList);

        let nrZile = Math.floor(dayDifference / dateList)

        // console.warn(nrZile)


        let counter = taskuriFilter.length



        objEtapa.x = ((window.innerWidth * 98) / 2) / 100
        objEtapa.clientWidth = (window.innerWidth * 98) / 100

        let sumaEtapa = dataFinish.getTime() - dataStart.getTime()

        let listSubtaskuri = []

        // console.log('objEtapa :', objEtapa);
        let taskuriBottom = -30

        for (let i = 0; i < counter; i++) {


            let dataSfTask = new Date(u.ParseDataFromSql(taskuriFilter[i].pana_cand_data))
            let dataInceputTask = new Date(u.ParseDataFromSql(taskuriFilter[i].cand_data))



            let sumaTask = dataSfTask.getTime() - dataInceputTask.getTime()

            let newMargin = dataInceputTask.getTime() - dataStart.getTime()

            // console.log('dataInceputTask :', dataInceputTask);
            // console.log('dataStart :', dataStart);

            let procentTask = Math.floor((newMargin / sumaEtapa) * 100)

            taskuriFilter[i].marginLeft = procentTask > 80 ? 80 : procentTask

            taskuriFilter[i].slider = 'none'

            let newProcentTask = Math.floor((sumaTask / sumaEtapa) * 100)

            taskuriFilter[i].procent = newProcentTask

            taskuriFilter[i].left = ((taskuriFilter[i].marginLeft + (taskuriFilter[i].procent / 2)) * objEtapa.clientWidth) / 100

            taskuriFilter[i].clientWidth = objEtapa.clientWidth * (taskuriFilter[i].procent) / 100

            taskuriFilter[i].clientLeft = (taskuriFilter[i].marginLeft * objEtapa.clientWidth) / 100
            let procentFilter = taskuriFilter.filter(t => t.id !== taskuriFilter[i].id)
            procentFilter = procentFilter.filter(tF => new Date(u.ParseDataFromSql(tF.pana_cand_data)) > new Date(u.ParseDataFromSql(taskuriFilter[i].cand_data)))


            if (procentFilter.length > 0) {
                taskuriBottom += -30 * (i + 1)

            } else {
                taskuriBottom = -60
            }

            taskuriFilter[i].bottom = taskuriBottom

            let ipo = Math.sqrt(Math.pow((objEtapa.x - taskuriFilter[i].left), 2) + Math.pow(-taskuriFilter[i].bottom, 2))

            taskuriFilter[i].degree = - ((objEtapa.x - taskuriFilter[i].left) / ipo) * (180 / 3.14)

            let subtaskuri = this.props.listSubTaskuri

            // console.log('listSubtaskuri :', listSubtaskuri);

            let filterSubtaskuri = subtaskuri.filter(t => t.id_task_parent === taskuriFilter[i].id)

            // console.warn('filterSubtaskuri', filterSubtaskuri)

            // console.warn('taskuriFilter[i]', taskuriFilter[i])
            // console.log('filterSubtaskuri :', filterSubtaskuri);


            filterSubtaskuri = filterSubtaskuri.filter(t => (new Date(u.ParseDataFromSql(t.cand_data)) < new Date(taskuriFilter[i].pana_cand_data) && new Date(u.ParseDataFromSql(t.pana_cand_data)) <= new Date(u.ParseDataFromSql(taskuriFilter[i].pana_cand_data))))
            // console.warn('filterSubtaskuri after date', filterSubtaskuri)

            // console.log('filterSubtaskuri :', filterSubtaskuri);

            let counter2 = filterSubtaskuri.length

            let subTaskuriBottom = -20

            for (let j = 0; j < counter2; j++) {
                let dataSfSubTask = new Date(u.ParseDataFromSql(filterSubtaskuri[j].pana_cand_data))
                let dataInceputSubTask = new Date(u.ParseDataFromSql(filterSubtaskuri[j].cand_data))



                let sumaSubTask = dataSfSubTask.getTime() - dataInceputSubTask.getTime()

                let newMarginSubtask = dataInceputSubTask.getTime() - dataInceputTask.getTime()


                let procentSubtask = Math.floor((newMarginSubtask / sumaTask) * 100)

                filterSubtaskuri[j].marginLeft = procentSubtask

                let newProcentSubtask = Math.floor((sumaSubTask / sumaTask) * 100)

                filterSubtaskuri[j].procent = newProcentSubtask

                filterSubtaskuri[j].left = ((filterSubtaskuri[j].marginLeft + (filterSubtaskuri[j].procent / 2)) * taskuriFilter[i].clientWidth) / 100 + taskuriFilter[i].clientLeft


                filterSubtaskuri[j].clientWidth = taskuriFilter[i].clientWidth * (filterSubtaskuri[j].procent) / 100

                filterSubtaskuri[j].clientLeft = (filterSubtaskuri[j].marginLeft * taskuriFilter[i].clientWidth) / 100

                let subTaskProcFilter = filterSubtaskuri.filter(t => t.id !== filterSubtaskuri[j].id)
                subTaskProcFilter = subTaskProcFilter.filter(tF => new Date(u.ParseDataFromSql(tF.pana_cand_data)) >= new Date(u.ParseDataFromSql(filterSubtaskuri[j].cand_data)))

                // console.log('subTaskProcFilter :', subTaskProcFilter);

                if (subTaskProcFilter.length > 0) {

                    taskuriBottom += -10 * (j + 1)
                    subTaskuriBottom = -30 * (j + 1)

                } else {
                    subTaskuriBottom = -30

                }
                // console.log('taskuriBottom :', taskuriBottom);

                filterSubtaskuri[j].bottom = subTaskuriBottom

                let ipo = Math.sqrt(Math.pow((taskuriFilter[i].left - filterSubtaskuri[j].left), 2) + Math.pow(-filterSubtaskuri[j].bottom, 2))

                filterSubtaskuri[j].degree = -((taskuriFilter[i].left - filterSubtaskuri[j].left) / ipo) * (180 / 3.14)

                listSubtaskuri.push(filterSubtaskuri[j])

                let subSubtaskuri = this.props.listSubTaskuri

                // console.log('this.props.listSubtaskuri :', this.props.listSubTaskuri);



                let filterSubSubtaskuri = subSubtaskuri.filter(t => t.id_task_parent === filterSubtaskuri[j].id)

                // console.log('filterSubSubtaskuri :', filterSubSubtaskuri);


                filterSubSubtaskuri = filterSubSubtaskuri.filter(t => (new Date(u.ParseDataFromSql(t.cand_data)) < new Date(filterSubtaskuri[j].pana_cand_data) && new Date(u.ParseDataFromSql(t.pana_cand_data)) <= new Date(u.ParseDataFromSql(filterSubtaskuri[j].pana_cand_data))))



                let counter3 = filterSubSubtaskuri.length

                let subTaskuriBottom1 = -30

                for (let q = 0; q < counter3; q++) {
                    let dataSfSubTask1 = new Date(u.ParseDataFromSql(filterSubSubtaskuri[q].pana_cand_data))
                    let dataInceputSubTask1 = new Date(u.ParseDataFromSql(filterSubSubtaskuri[q].cand_data))



                    let sumaSubTask1 = dataSfSubTask1.getTime() - dataInceputSubTask1.getTime()

                    let newMarginSubtask1 = dataInceputSubTask1.getTime() - dataInceputSubTask.getTime()


                    let procentSubtask1 = Math.floor((newMarginSubtask1 / sumaTask) * 100)

                    filterSubSubtaskuri[q].marginLeft = procentSubtask1

                    let newprocentSubtask1 = Math.floor((sumaSubTask1 / sumaTask) * 100)

                    filterSubSubtaskuri[q].procent = newprocentSubtask1

                    filterSubSubtaskuri[q].left = ((filterSubSubtaskuri[q].marginLeft + (filterSubSubtaskuri[q].procent / 2)) * filterSubtaskuri[j].clientWidth) / 100 + filterSubtaskuri[j].clientLeft


                    filterSubSubtaskuri[q].clientWidth = filterSubtaskuri[j].clientWidth * (filterSubSubtaskuri[q].procent) / 100

                    filterSubSubtaskuri[q].clientLeft = (filterSubSubtaskuri[q].marginLeft * filterSubtaskuri[j].clientWidth) / 100

                    let subTaskProcFilter = filterSubSubtaskuri.filter(t => t.id !== filterSubSubtaskuri[q].id)
                    subTaskProcFilter = subTaskProcFilter.filter(tF => new Date(u.ParseDataFromSql(tF.pana_cand_data)) >= new Date(u.ParseDataFromSql(filterSubSubtaskuri[q].cand_data)))

                    // console.log('subTaskProcFilter :', subTaskProcFilter);



                    if (subTaskProcFilter.length > 0) {




                        taskuriBottom += -30

                        subTaskuriBottom += -30

                        subTaskuriBottom1 += -30 * (q + 1)

                    } else {
                        subTaskuriBottom1 = -30



                    }
                    // console.log('taskuriBottom :', taskuriBottom);

                    filterSubSubtaskuri[q].bottom = subTaskuriBottom1

                    let ipo = Math.sqrt(Math.pow((filterSubtaskuri[j].left - filterSubSubtaskuri[q].left), 2) + Math.pow(-filterSubSubtaskuri[q].bottom, 2))

                    filterSubSubtaskuri[q].degree = -((filterSubtaskuri[j].left - filterSubSubtaskuri[q].left) / ipo) * (180 / 3.14)

                    listSubtaskuri.push(filterSubSubtaskuri[q])


                    let subSubtaskuri2 = this.props.listSubTaskuri

                    // console.log('this.props.listSubtaskuri :', this.props.listSubTaskuri);



                    let filterSubSubtaskuri2 = subSubtaskuri2.filter(t => t.id_task_parent === filterSubSubtaskuri[q].id)

                    // console.log('filterSubSubtaskuri :', filterSubSubtaskuri);


                    filterSubSubtaskuri2 = filterSubSubtaskuri2.filter(t => (new Date(u.ParseDataFromSql(t.cand_data)) < new Date(filterSubSubtaskuri[q].pana_cand_data) && new Date(u.ParseDataFromSql(t.pana_cand_data)) <= new Date(filterSubSubtaskuri[q].pana_cand_data)))



                    let counter4 = filterSubSubtaskuri2.length

                    let subTaskuriBottom2 = -30

                    for (let k = 0; k < counter4; k++) {
                        let dataSfSubTask2 = new Date(u.ParseDataFromSql(filterSubSubtaskuri2[k].pana_cand_data))
                        let dataInceputSubTask2 = new Date(u.ParseDataFromSql(filterSubSubtaskuri2[k].cand_data))



                        let sumaSubTask2 = dataSfSubTask2.getTime() - dataInceputSubTask2.getTime()

                        let newMarginSubtask2 = dataInceputSubTask2.getTime() - dataInceputSubTask1.getTime()


                        let procentSubtask2 = Math.floor((newMarginSubtask2 / sumaSubTask1) * 100)

                        filterSubSubtaskuri2[k].marginLeft = procentSubtask2 > '80%' ? '80%' : procentSubtask2

                        let newprocentSubtask2 = Math.floor((sumaSubTask2 / sumaSubTask1) * 100)

                        filterSubSubtaskuri2[k].procent = newprocentSubtask2

                        filterSubSubtaskuri2[k].left = ((filterSubSubtaskuri2[k].marginLeft + (filterSubSubtaskuri2[k].procent / 2)) * filterSubSubtaskuri[q].clientWidth) / 100 + filterSubSubtaskuri[q].clientLeft


                        filterSubSubtaskuri2[k].clientWidth = filterSubSubtaskuri[q].clientWidth * (filterSubSubtaskuri2[k].procent) / 100

                        filterSubSubtaskuri2[k].clientLeft = (filterSubSubtaskuri2[k].marginLeft * filterSubSubtaskuri[q].clientWidth) / 100

                        let subTaskProcFilter2 = filterSubSubtaskuri2.filter(t => t.id !== filterSubSubtaskuri2[k].id)
                        subTaskProcFilter2 = subTaskProcFilter2.filter(tF => new Date(u.ParseDataFromSql(tF.pana_cand_data)) >= new Date(u.ParseDataFromSql(filterSubSubtaskuri2[k].cand_data)))

                        // console.log('subTaskProcFilter :', subTaskProcFilter);



                        if (subTaskProcFilter2.length > 0) {




                            taskuriBottom += -30

                            subTaskuriBottom += -30

                            subTaskuriBottom1 += -30

                            subTaskuriBottom2 = -30 * (k + 1)

                        } else {


                            subTaskuriBottom2 = -30

                        }
                        // console.log('taskuriBottom :', taskuriBottom);

                        filterSubSubtaskuri2[k].bottom = subTaskuriBottom2

                        let ipo = Math.sqrt(Math.pow((filterSubSubtaskuri[q].clientLeft - filterSubSubtaskuri2[k].left), 2) + Math.pow(- filterSubSubtaskuri2[k].bottom, 2))

                        filterSubSubtaskuri2[k].degree = -((filterSubSubtaskuri[q].clientLeft - filterSubSubtaskuri2[k].left) / ipo) * (180 / 3.14)

                        listSubtaskuri.push(filterSubSubtaskuri2[k])

                    }
                }
            }



        }

        // console.log('listSubtaskuri :', listSubtaskuri);

        console.log('taskuriFilter :', taskuriFilter);

        console.log('this.props.objTaskSelectat :>> ', this.props.objTaskSelectat);




        let taskSelectatId;

        if (this.props.objTaskSelectat) {
            taskSelectatId = this.props.objTaskSelectat !== undefined ? this.props.objTaskSelectat.id : 0
        } else {
            taskSelectatId = 0
        }



        let container = <div style={{ width: '100%', height: '100%', minHeight: 100, marginTop: 30, }}>
            <div id={'etapaID'} style={{ width: `98%`, boxSizing: 'border-box', margin: 'auto', position: 'relative', textAlign: 'left' }}>
                {/* <span>
                    <input className='slider-date'
                        type='range'
                        id={`slider-task-date`}
                        style={{
                            display: 'none',
                            position: 'absolute',
                            left: 0,
                            right: 0,
                            margin: 'auto',
                            width: '100%',
                            bottom: -15
                        }}
                        min='0'
                        max={`${nrZile}`}
                        step={1}
                        name='pm-slider'
                        onMouseUp={(ev) => { this.hideSlider(ev) }}
                        onChange={(ev) => { this.changeSlideVal(ev) }}
                        value={this.state.slideValue} />
                </span> */}
                {/* <div onMouseEnter={() => { this.props.userView ? (console.log('object :')) : this.showEdit(`edit-etapa`) }} className='pm-proiect-integral-etapa'
                    style={{
                        boxSizing: 'border-box',

                        width: '98%',
                        backgroundColor: objEtapa.color,


                        borderBottomLeftRadius: 30,
                        borderTopLeftRadius: 30,
                        borderBottomRightRadius: 30,
                        borderTopRightRadius: 30
                    }}> */}
                <div id='pm-change-etapa-view'>
                    <h3 style={{ marginBottom: 20, width: 'fit-content' }}>Stadiul {this.props.indexEtapa + 1} - {objEtapa.denumire}</h3>

                    {/* <div style={{
                        marginTop: 13,
                        marginLeft: 10
                    }} >


                        <span style={{verticalAlign:'super'}}>Mod Vizionare</span>
                        <i onClick={() => { this.changeViewOption('think') }} style={{cursor:'pointer'}} className='material-icons'>emoji_objects</i>
                        <i style={{color:'blue', cursor:'pointer'}}  onClick={() => { this.changeViewOption('gantt') }} className='material-icons'>clear_all</i>
                        <i onClick={() => { this.changeViewOption('tabel') }} style={{cursor:'pointer'}} className='material-icons'>table_chart</i>

                    


                    </div> */}

                </div>


                {taskuriFilter.length === 0 &&
                    <div>
                        <span style={{ fontWeight: 400, fontSize: 12, verticalAlign: '-webkit-baseline-middle' }}>{this.dictionary.proiecte.noTaskInEtapa} </span>

                    </div>
                }


                {/* <i onClick={() => { this.props.editEtapa(objEtapa) }} id={`edit-etapa`} className='material-icons pm-edit-task'>create</i> */}
                {/* </div> */}
                {taskuriFilter.map((t, idxT) => {
                    // console.log('t :>> ', t);

                    return (
                        // <Hidden key={`taskuri${idxT}`} mdDown>
                        <div
                            // onMouseEnter={() => { this.showEdit(`edit-task-etapa${t.id}`) }} 

                            className='pm-task-etapa-integral' key={`taskuri${idxT}`}
                            id={`taskuri${idxT}`}
                            onMouseEnter={() => { this.props.showTag(t) }}
                            onMouseLeave={() => { this.props.hideTag(t) }}
                            // draggable
                            onDragStart={(ev)=>{this.props.dragStart(t,ev)}}
                  
                            onDragEnd={(ev)=>{this.props.dragEnd(ev)}}
                            style={{
                                width: `${t.procent}%`,
                                minWidth: 150,
                                position: 'relative',
                                marginTop: 20,
                                marginLeft: `${t.marginLeft}%`,
                                backgroundColor: t.color,


                                border: taskSelectatId === t.id ? `1px solid rgb(254	193	53	)` : '',

                            }}>

                            {/* <span className='pm-data-inceput-task'>{this.arataData(t.cand_data) + '-' + this.arataData(t.pana_cand_data)}</span> */}


                            {t.procent_completare > 0 &&
                                <div onClick={() => { this.props.goToTask(t) }} style={{
                                    backgroundColor: 'rgb(225 225 224)',
                                    position: 'absolute',
                                    width: (100 - t.procent_completare) + '%',
                                    height: '100%',
                                    right: 0,
                                    top: 0,

                                    borderTopRightRadius: 18,
                                    borderBottomRightRadius: 18
                                }}>
                                    <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                                        {t.subtaskuri_trecute > 0 && t.in_lucru &&
                                            <i style={{
                                                color: 'white',
                                                fontSize: 12,
                                                backgroundColor: 'red',
                                                borderRadius: '50%',
                                                padding: 1,
                                                position: 'absolute',
                                                bottom: 0,
                                                left: -5
                                            }} className='material-icons'>priority_high</i>

                                        }
                                    </div>
                                </div>
                            }


                            <div style={{ position: 'relative', width: '100%', display: 'flex' }}>
                                <div className='etapa-tag' style={{
                                    position: 'absolute', display: t.show_tag ? 'block' : 'none', top: 35,
                                    zIndex:1200,
                                    left: -25, color: 'black'
                                }}>
                                    <div className='etapa-tag-container' style={{ position: 'relative' }}>


                                        <div style={{
                                            position: 'absolute',
                                          
                                            top: -11,
                                            left: 70
                                        }} className='triangle-up'>

                                        </div>

                                        <h4 style={{ marginBottom: 5 }}> {t.titlu} </h4>
                                        <span style={{ marginTop: 5, display: "block", fontSize: 14 }}>{this.dictionary.proiecte.duration} :{new Utils().dataPrescurtataRomana(t.cand_data)} - {new Utils().dataPrescurtataRomana(t.pana_cand_data)} </span>
                                        {t.subtaskuri.length > 0 &&


                                            <span style={{ marginTop: 5, display: "block", fontSize: 14 }}>{this.dictionary.proiecte.gradDeCompletare}:{t.procent_completare}% </span>
                                        }

                                        {t.statusul === 'Finalizat' &&
                                            <span style={{ marginTop: 5, display: "block", fontSize: 14 }}>{this.dictionary.proiecte.completedAt}:{new Utils().dataPrescurtataRomana(t.cand_finalizat)}</span>
                                        }



                                        <span style={{ marginTop: 5, display: "block", fontSize: 14 }}>{this.dictionary.proiecte.subtasksNumber}:{t.subtaskuri.length} </span>



                                        {t.subtaskuri_trecute > 0 && t.in_lucru &&
                                            <span style={{ marginTop: 5, display: "block", fontSize: 14 }}><i style={{
                                                color: 'white',
                                                fontSize: 12,
                                                backgroundColor: 'red',
                                                borderRadius: '50%',
                                                padding: 1,

                                            }} className='material-icons'>priority_high</i> {t.subtaskuri_trecute} {t.subtaskuri_trecute > 1 ? this.dictionary.proiecte.subtasksTermenDepasit : this.dictionary.proiecte.subtaskTermenDepasit}</span>
                                        }
                                    </div>

                                </div>

                                {!t.show_change_arrow && t.subtaskuri.length < 1 && 
                                    <i onClick={() => { this.props.finalizeazaTask(t) }} style={{
                                        backgroundColor: 'white',
                                        cursor: 'pointer',
                                        color: t.statusul === 'Finalizat' ? 'rgb(24, 166, 59)' : 'black',
                                        borderRadius: 20,
                                        padding: 3,
                                        verticalAlign: 'middle',
                                        display: t.show_tag ? 'inline-flex' : 'none',
                                        // display:'inline-flex'
                                        // position: 'absolute', left: 0, top: -5
                                    }} className='material-icons'>check_circle_outline</i>
                                }


                                <span onClick={() => { this.props.goToTask(t) }} style={{ cursor: 'pointer', display: 'inline-flex' }} className='pm-task-etapa-titlu'>  {t.titlu}</span>

                            </div>


                            {
                                !t.show_change_arrow &&
                                <div style={{ position: 'absolute', right: 3, top: 0, zIndex: 1002, cursor: 'pointer', display: 'flex' }}>






                                    {t.show_tag &&
                                        <TaskMenu
                                            callBack={this.callBack}
                                            menuItems={[{ id: 1, name:this.dictionary.proiecte.manageTask , task: t },
                                             { id: 2, name:this.dictionary.proiecte.modifyInteractiveData  , task: t }
                                            ]}

                                        />
                                    }

                                    {this.showAvatar(t)}





                                </div>
                            }





                            {
                                t.show_change_arrow &&

                                <i onMouseUp={() => { this.removeEventMouseDownLeft() }} id={`datachange${idxT}`} onMouseDown={() => { this.changeSizeLeft(t, `taskuri${idxT}`, `datachange${idxT}`) }} className='material-icons backwards-arrow'>forward</i>
                            }

                            {
                                t.show_change_arrow &&
                                <div style={{ position: 'absolute', left: 3, top: 0, zIndex: 1002, cursor: 'pointer', display: 'flex' }}>



                                    <IconButton
                                        style={{ padding: 1, marginTop: 3, backgroundColor: 'white' }}
                                        aria-controls='simple-menu' aria-haspopup="true" onClick={() => { this.props.hideChangeArrow(t) }}>
                                        <i style={{ fontSize: 33, color: 'black' }} className='material-icons'>
                                            check_circle_outline
                                    </i>
                                    </IconButton>





                                </div>
                            }


                            {
                                t.show_change_arrow &&
                                <div
                               
                                style={{ position: 'absolute', right: 3, top: 0, zIndex: 1002, cursor: 'pointer', display: 'flex' }}>



                                    <IconButton
                                        style={{ padding: 1, marginTop: 3, backgroundColor: 'white' }}
                                        aria-controls='simple-menu' aria-haspopup="true" >

                                     
                                        <i style={{ fontSize: 33, color: 'black' }} className='material-icons'>
                                            more_vert
                                    </i>
                                    </IconButton>





                                </div>
                            }


                            {
                                t.show_change_arrow &&

                                <i onMouseUp={() => { this.removeEventMouseDown() }} id={`datachange${idxT}`} onMouseDown={() => { this.changeSize(t, `taskuri${idxT}`, `datachange${idxT}`) }} className='material-icons forward-arrow'>forward</i>
                            }




                            {/* <i onClick={() => { this.props.editTask(t, objEtapa) }} id={`edit-task-etapa${t.id}`} className='material-icons pm-edit-task'>create</i> */}




                            {/* <i style={{
                                        color: '#adadad',
                                        position: 'absolute',
                                        display: this.props.userView ? 'none' : 'block',
                                        left: -25,
                                        fontSize: 30,
                                        top: 2
                                    }} onClick={() => { this.openSlide(t, 'cand_data', `slider-task-date`, objEtapa) }} className='material-icons '>arrow_back</i> */}
                            {/* <i style={{
                                        color: '#adadad',
                                        position: 'absolute',
                                        display: this.props.userView ? 'none' : 'block',
                                        fontSize: 30,
                                        top: 2,
                                        right: -25
                                    }} onClick={() => { this.openSlide(t, 'pana_cand_data', `slider-task-date`, objEtapa) }} className='material-icons '>arrow_forward</i> */}


                            {/* <div className='pm-task-etapa-line' style={{
                                        height: - t.bottom || 0,
                                        top: t.bottom || 0,
                                        transform: `skew(${t.degree}deg)`
                                    }}>

                                    </div> */}
                            {/* {listSubtaskuri.filter(st => st.id_task_parent === t.id).map((st, idxSt) => {
                                return (
                                    <div className='pm-sub-task-integral' key={`subTaskuri${idxSt}`} style={{
                                        width: `${st.procent}%`,

                                        bottom: st.bottom,
                                        left: `${st.marginLeft}%`,
                                        backgroundColor: st.color
                                    }}>
                                        <span onClick={() => { this.props.goToTask(st) }} style={{ backgroundColor: st.color }} className='pm-sub-task-titlu'>{st.titlu}</span>

                                        <div className='pm-task-etapa-line' style={{
                                            height: - st.bottom || 0,
                                            top: st.bottom || 0,
                                            transform: `skew(${st.degree}deg)`
                                        }}>

                                        </div>

                                        {listSubtaskuri.filter(sst => sst.id_task_parent === st.id).map((sst, idxSSt) => {
                                            return (
                                                <div className='pm-sub-task-integral' key={`subTaskuri${idxSSt}`} style={{
                                                    width: `${sst.procent}%`,

                                                    bottom: sst.bottom,
                                                    left: `${sst.marginLeft}%`,
                                                    backgroundColor: sst.color
                                                }}>
                                                    <span onClick={() => { this.props.goToTask(sst) }} style={{ backgroundColor: sst.color }} className='pm-sub-task-titlu'>{sst.titlu}</span>

                                                    <div className='pm-task-etapa-line' style={{
                                                        height: -sst.bottom || 0,
                                                        top: sst.bottom || 0,
                                                        transform: `skew(${sst.degree}deg)`
                                                    }}>

                                                    </div>
                                                    {listSubtaskuri.filter(ssst => ssst.id_task_parent === sst.id).map((ssst, idxSSSt) => {
                                                        return (
                                                            <div className='pm-sub-task-integral' key={`subTaskuri${idxSSSt}`} style={{
                                                                width: `${ssst.procent}%`,

                                                                bottom: ssst.bottom,
                                                                left: `${ssst.marginLeft}%`,
                                                                backgroundColor: ssst.color
                                                            }}>
                                                                <span onClick={() => { this.props.goToTask(ssst) }} style={{ backgroundColor: ssst.color }} className='pm-sub-task-titlu'>{ssst.titlu}</span>

                                                                <div className='pm-task-etapa-line' style={{
                                                                    height: -ssst.bottom || 0,
                                                                    top: ssst.bottom || 0,
                                                                    transform: `skew(${ssst.degree}deg)`
                                                                }}>

                                                                </div>
                                                            </div>
                                                        )


                                                    })}
                                                </div>
                                            )


                                        })}
                                    </div>
                                )


                            })} */}



                        </div>



                    )
                })}

                <div style={{marginTop:20}}>
                    <Button style={{ display: 'block', padding: 10, backgroundColor: 'rgb(24 166 59)', color: 'white', fontWeight: 500 }} onClick={() => { this.props.insertTask(this.props.objEtapaSelectata) }}  >
                        <i style={{verticalAlign:'sub'}} className='material-icons pm-round-button-text'>add</i>
                        {this.dictionary.proiecte.newTask}
                            </Button>
                </div>

                {/* {taskuriFilter.map((t, idxT) => {

                        return (
                            <Hidden key={`taskuri${idxT}`} smUp>
                                <div onMouseEnter={() => { this.showEdit(`edit-task-etapa${t.id}`) }} className='pm-task-etapa-integral' key={`taskuri${idxT}`} style={{
                                    width: `90%`,
                                    position: 'relative',
                                    marginTop: 10,
                                    marginBottom: 5,
                                    backgroundColor: t.color,
                                    height: 'fit-content'
                                }}>

                                    <span className='pm-data-inceput-task'>{this.arataData(t.cand_data) + '-' + this.arataData(t.pana_cand_data)}</span>
                                    <span onClick={() => { this.props.goToTask(t) }} style={{ backgroundColor: t.color }} className='pm-task-etapa-titlu'>{t.titlu}</span>
                                    <i onClick={() => { this.props.editTask(t, objEtapa) }} id={`edit-task-etapa${t.id}`} className='material-icons pm-edit-task'>create</i>


                                </div>

                                {listSubtaskuri.filter(st => st.id_task_parent === t.id).map((st, idxSt) => {
                                    return (
                                        <div className='pm-sub-task-integral' key={`subTaskuri${idxSt}`} style={{
                                            width: `90%`,
                                            position: 'relative',
                                            marginLeft: 20,
                                            marginBottom: 5,
                                            backgroundColor: st.color,
                                            height: 'fit-content'
                                        }}>
                                            <span onClick={() => { this.props.goToTask(st) }} style={{ backgroundColor: st.color }} className='pm-sub-task-titlu'>{st.titlu}</span>



                                            {listSubtaskuri.filter(sst => sst.id_task_parent === st.id).map((sst, idxSSt) => {
                                                return (
                                                    <div className='pm-sub-task-integral' key={`subTaskuri${idxSSt}`} style={{
                                                        width: `${sst.procent}%`,

                                                        bottom: sst.bottom,
                                                        left: `${sst.marginLeft}%`,
                                                        backgroundColor: sst.color
                                                    }}>
                                                        <span onClick={() => { this.props.goToTask(sst) }} style={{ backgroundColor: sst.color }} className='pm-sub-task-titlu'>{sst.titlu}</span>


                                                        {listSubtaskuri.filter(ssst => ssst.id_task_parent === sst.id).map((ssst, idxSSSt) => {
                                                            return (
                                                                <div className='pm-sub-task-integral' key={`subTaskuri${idxSSSt}`} style={{
                                                                    width: `${ssst.procent}%`,

                                                                    bottom: ssst.bottom,
                                                                    left: `${ssst.marginLeft}%`,
                                                                    backgroundColor: ssst.color
                                                                }}>
                                                                    <span onClick={() => { this.props.goToTask(ssst) }} style={{ backgroundColor: ssst.color }} className='pm-sub-task-titlu'>{ssst.titlu}</span>

                                                                    <div className='pm-task-etapa-line' style={{
                                                                        height: -ssst.bottom || 0,
                                                                        top: ssst.bottom || 0,
                                                                        transform: `skew(${ssst.degree}deg)`
                                                                    }}>

                                                                    </div>
                                                                </div>
                                                            )


                                                        })}
                                                    </div>
                                                )


                                            })}
                                        </div>
                                    )


                                })}






                            </Hidden>

                        )
                    })} */}

            </div>

        </div >


        return container

    }



    listBodyTable = () => {

        let u = new Utils();

        let objEtapa = this.props.objEtapaSelectata
        let listTaskuri = this.props.listTaskuri



        let taskuriFilter = listTaskuri.filter(t => t.id_etapa_proiect === objEtapa.id)

        taskuriFilter = taskuriFilter.filter(t => (new Date(u.ParseDataFromSql(t.cand_data)) < new Date(objEtapa.durata_pana_la) && new Date(u.ParseDataFromSql(t.pana_cand_data)) <= new Date(objEtapa.durata_pana_la)))




        let dataStart = new Date(objEtapa.durata_de_la)
        let dataFinish = new Date(objEtapa.durata_pana_la)


        let timeDiff = Math.abs(dataFinish.getTime() - dataStart.getTime());

        let dayDifference = Math.ceil(timeDiff / (1000 * 3600 * 24));

        let dateList = Math.ceil(dayDifference / this.props.screenLimit)

        // console.warn('dateList :', dateList);

        let nrZile = Math.floor(dayDifference / dateList)

        // console.warn(nrZile)


        let counter = taskuriFilter.length



        objEtapa.x = ((window.innerWidth * 98) / 2) / 100
        objEtapa.clientWidth = (window.innerWidth * 98) / 100

        let sumaEtapa = dataFinish.getTime() - dataStart.getTime()

        let listSubtaskuri = []

        // console.log('objEtapa :', objEtapa);
        let taskuriBottom = -30

        for (let i = 0; i < counter; i++) {


            let dataSfTask = new Date(u.ParseDataFromSql(taskuriFilter[i].pana_cand_data))
            let dataInceputTask = new Date(u.ParseDataFromSql(taskuriFilter[i].cand_data))



            let sumaTask = dataSfTask.getTime() - dataInceputTask.getTime()

            let newMargin = dataInceputTask.getTime() - dataStart.getTime()


            let procentTask = Math.floor((newMargin / sumaEtapa) * 100)

            taskuriFilter[i].marginLeft = procentTask

            taskuriFilter[i].slider = 'none'

            let newProcentTask = Math.floor((sumaTask / sumaEtapa) * 100)

            taskuriFilter[i].procent = newProcentTask

            taskuriFilter[i].left = ((taskuriFilter[i].marginLeft + (taskuriFilter[i].procent / 2)) * objEtapa.clientWidth) / 100

            taskuriFilter[i].clientWidth = objEtapa.clientWidth * (taskuriFilter[i].procent) / 100

            taskuriFilter[i].clientLeft = (taskuriFilter[i].marginLeft * objEtapa.clientWidth) / 100
            let procentFilter = taskuriFilter.filter(t => t.id !== taskuriFilter[i].id)
            procentFilter = procentFilter.filter(tF => new Date(u.ParseDataFromSql(tF.pana_cand_data)) > new Date(u.ParseDataFromSql(taskuriFilter[i].cand_data)))


            if (procentFilter.length > 0) {
                taskuriBottom += -30 * (i + 1)

            } else {
                taskuriBottom = -60
            }

            taskuriFilter[i].bottom = taskuriBottom

            let ipo = Math.sqrt(Math.pow((objEtapa.x - taskuriFilter[i].left), 2) + Math.pow(-taskuriFilter[i].bottom, 2))

            taskuriFilter[i].degree = - ((objEtapa.x - taskuriFilter[i].left) / ipo) * (180 / 3.14)

            let subtaskuri = this.props.listSubTaskuri


            let filterSubtaskuri = subtaskuri.filter(t => t.id_task_parent === taskuriFilter[i].id)




            filterSubtaskuri = filterSubtaskuri.filter(t => (new Date(u.ParseDataFromSql(t.cand_data)) < new Date(taskuriFilter[i].pana_cand_data) && new Date(u.ParseDataFromSql(t.pana_cand_data)) <= new Date(u.ParseDataFromSql(taskuriFilter[i].pana_cand_data))))


            let counter2 = filterSubtaskuri.length

            let subTaskuriBottom = -20

            for (let j = 0; j < counter2; j++) {
                let dataSfSubTask = new Date(u.ParseDataFromSql(filterSubtaskuri[j].pana_cand_data))
                let dataInceputSubTask = new Date(u.ParseDataFromSql(filterSubtaskuri[j].cand_data))



                let sumaSubTask = dataSfSubTask.getTime() - dataInceputSubTask.getTime()

                let newMarginSubtask = dataInceputSubTask.getTime() - dataInceputTask.getTime()


                let procentSubtask = Math.floor((newMarginSubtask / sumaTask) * 100)

                filterSubtaskuri[j].marginLeft = procentSubtask

                let newProcentSubtask = Math.floor((sumaSubTask / sumaTask) * 100)

                filterSubtaskuri[j].procent = newProcentSubtask

                filterSubtaskuri[j].left = ((filterSubtaskuri[j].marginLeft + (filterSubtaskuri[j].procent / 2)) * taskuriFilter[i].clientWidth) / 100 + taskuriFilter[i].clientLeft


                filterSubtaskuri[j].clientWidth = taskuriFilter[i].clientWidth * (filterSubtaskuri[j].procent) / 100

                filterSubtaskuri[j].clientLeft = (filterSubtaskuri[j].marginLeft * taskuriFilter[i].clientWidth) / 100

                let subTaskProcFilter = filterSubtaskuri.filter(t => t.id !== filterSubtaskuri[j].id)
                subTaskProcFilter = subTaskProcFilter.filter(tF => new Date(u.ParseDataFromSql(tF.pana_cand_data)) >= new Date(u.ParseDataFromSql(filterSubtaskuri[j].cand_data)))

                // console.log('subTaskProcFilter :', subTaskProcFilter);

                if (subTaskProcFilter.length > 0) {

                    taskuriBottom += -10 * (j + 1)
                    subTaskuriBottom = -30 * (j + 1)

                } else {
                    subTaskuriBottom = -30

                }
                // console.log('taskuriBottom :', taskuriBottom);

                filterSubtaskuri[j].bottom = subTaskuriBottom

                let ipo = Math.sqrt(Math.pow((taskuriFilter[i].left - filterSubtaskuri[j].left), 2) + Math.pow(-filterSubtaskuri[j].bottom, 2))

                filterSubtaskuri[j].degree = -((taskuriFilter[i].left - filterSubtaskuri[j].left) / ipo) * (180 / 3.14)

                listSubtaskuri.push(filterSubtaskuri[j])

                let subSubtaskuri = this.props.listSubTaskuri

                // console.log('this.props.listSubtaskuri :', this.props.listSubTaskuri);



                let filterSubSubtaskuri = subSubtaskuri.filter(t => t.id_task_parent === filterSubtaskuri[j].id)

                // console.log('filterSubSubtaskuri :', filterSubSubtaskuri);


                filterSubSubtaskuri = filterSubSubtaskuri.filter(t => (new Date(u.ParseDataFromSql(t.cand_data)) < new Date(filterSubtaskuri[j].pana_cand_data) && new Date(u.ParseDataFromSql(t.pana_cand_data)) <= new Date(u.ParseDataFromSql(filterSubtaskuri[j].pana_cand_data))))



                let counter3 = filterSubSubtaskuri.length

                let subTaskuriBottom1 = -30

                for (let q = 0; q < counter3; q++) {
                    let dataSfSubTask1 = new Date(u.ParseDataFromSql(filterSubSubtaskuri[q].pana_cand_data))
                    let dataInceputSubTask1 = new Date(u.ParseDataFromSql(filterSubSubtaskuri[q].cand_data))



                    let sumaSubTask1 = dataSfSubTask1.getTime() - dataInceputSubTask1.getTime()

                    let newMarginSubtask1 = dataInceputSubTask1.getTime() - dataInceputSubTask.getTime()


                    let procentSubtask1 = Math.floor((newMarginSubtask1 / sumaTask) * 100)

                    filterSubSubtaskuri[q].marginLeft = procentSubtask1

                    let newprocentSubtask1 = Math.floor((sumaSubTask1 / sumaTask) * 100)

                    filterSubSubtaskuri[q].procent = newprocentSubtask1

                    filterSubSubtaskuri[q].left = ((filterSubSubtaskuri[q].marginLeft + (filterSubSubtaskuri[q].procent / 2)) * filterSubtaskuri[j].clientWidth) / 100 + filterSubtaskuri[j].clientLeft


                    filterSubSubtaskuri[q].clientWidth = filterSubtaskuri[j].clientWidth * (filterSubSubtaskuri[q].procent) / 100

                    filterSubSubtaskuri[q].clientLeft = (filterSubSubtaskuri[q].marginLeft * filterSubtaskuri[j].clientWidth) / 100

                    let subTaskProcFilter = filterSubSubtaskuri.filter(t => t.id !== filterSubSubtaskuri[q].id)
                    subTaskProcFilter = subTaskProcFilter.filter(tF => new Date(u.ParseDataFromSql(tF.pana_cand_data)) >= new Date(u.ParseDataFromSql(filterSubSubtaskuri[q].cand_data)))

                    // console.log('subTaskProcFilter :', subTaskProcFilter);



                    if (subTaskProcFilter.length > 0) {




                        taskuriBottom += -30

                        subTaskuriBottom += -30

                        subTaskuriBottom1 += -30 * (q + 1)

                    } else {
                        subTaskuriBottom1 = -30



                    }
                    // console.log('taskuriBottom :', taskuriBottom);

                    filterSubSubtaskuri[q].bottom = subTaskuriBottom1

                    let ipo = Math.sqrt(Math.pow((filterSubtaskuri[j].left - filterSubSubtaskuri[q].left), 2) + Math.pow(-filterSubSubtaskuri[q].bottom, 2))

                    filterSubSubtaskuri[q].degree = -((filterSubtaskuri[j].left - filterSubSubtaskuri[q].left) / ipo) * (180 / 3.14)

                    listSubtaskuri.push(filterSubSubtaskuri[q])


                    let subSubtaskuri2 = this.props.listSubTaskuri

                    // console.log('this.props.listSubtaskuri :', this.props.listSubTaskuri);



                    let filterSubSubtaskuri2 = subSubtaskuri2.filter(t => t.id_task_parent === filterSubSubtaskuri[q].id)

                    // console.log('filterSubSubtaskuri :', filterSubSubtaskuri);


                    filterSubSubtaskuri2 = filterSubSubtaskuri2.filter(t => (new Date(u.ParseDataFromSql(t.cand_data)) < new Date(filterSubSubtaskuri[q].pana_cand_data) && new Date(u.ParseDataFromSql(t.pana_cand_data)) <= new Date(filterSubSubtaskuri[q].pana_cand_data)))



                    let counter4 = filterSubSubtaskuri2.length

                    let subTaskuriBottom2 = -30

                    for (let k = 0; k < counter4; k++) {
                        let dataSfSubTask2 = new Date(u.ParseDataFromSql(filterSubSubtaskuri2[k].pana_cand_data))
                        let dataInceputSubTask2 = new Date(u.ParseDataFromSql(filterSubSubtaskuri2[k].cand_data))



                        let sumaSubTask2 = dataSfSubTask2.getTime() - dataInceputSubTask2.getTime()

                        let newMarginSubtask2 = dataInceputSubTask2.getTime() - dataInceputSubTask1.getTime()


                        let procentSubtask2 = Math.floor((newMarginSubtask2 / sumaSubTask1) * 100)

                        filterSubSubtaskuri2[k].marginLeft = procentSubtask2

                        let newprocentSubtask2 = Math.floor((sumaSubTask2 / sumaSubTask1) * 100)

                        filterSubSubtaskuri2[k].procent = newprocentSubtask2

                        filterSubSubtaskuri2[k].left = ((filterSubSubtaskuri2[k].marginLeft + (filterSubSubtaskuri2[k].procent / 2)) * filterSubSubtaskuri[q].clientWidth) / 100 + filterSubSubtaskuri[q].clientLeft


                        filterSubSubtaskuri2[k].clientWidth = filterSubSubtaskuri[q].clientWidth * (filterSubSubtaskuri2[k].procent) / 100

                        filterSubSubtaskuri2[k].clientLeft = (filterSubSubtaskuri2[k].marginLeft * filterSubSubtaskuri[q].clientWidth) / 100

                        let subTaskProcFilter2 = filterSubSubtaskuri2.filter(t => t.id !== filterSubSubtaskuri2[k].id)
                        subTaskProcFilter2 = subTaskProcFilter2.filter(tF => new Date(u.ParseDataFromSql(tF.pana_cand_data)) >= new Date(u.ParseDataFromSql(filterSubSubtaskuri2[k].cand_data)))

                        // console.log('subTaskProcFilter :', subTaskProcFilter);



                        if (subTaskProcFilter2.length > 0) {




                            taskuriBottom += -30

                            subTaskuriBottom += -30

                            subTaskuriBottom1 += -30

                            subTaskuriBottom2 = -30 * (k + 1)

                        } else {


                            subTaskuriBottom2 = -30

                        }
                        // console.log('taskuriBottom :', taskuriBottom);

                        filterSubSubtaskuri2[k].bottom = subTaskuriBottom2

                        let ipo = Math.sqrt(Math.pow((filterSubSubtaskuri[q].clientLeft - filterSubSubtaskuri2[k].left), 2) + Math.pow(- filterSubSubtaskuri2[k].bottom, 2))

                        filterSubSubtaskuri2[k].degree = -((filterSubSubtaskuri[q].clientLeft - filterSubSubtaskuri2[k].left) / ipo) * (180 / 3.14)

                        listSubtaskuri.push(filterSubSubtaskuri2[k])

                    }
                }
            }



        }

        // console.log('listSubtaskuri :', listSubtaskuri);

        // console.log('taskuriFilter :', taskuriFilter);

        console.log('this.props.objTaskSelectat :>> ', this.props.objTaskSelectat);




        let taskSelectatId;

        if (this.props.objTaskSelectat) {
            taskSelectatId = this.props.objTaskSelectat !== undefined ? this.props.objTaskSelectat.id : 0
        } else {
            taskSelectatId = 0
        }



        let container = <div style={{ width: '100%', height: '100%', minHeight: 100, marginTop: 30, }}>
            <div id={'etapaID'} style={{ width: `98%`, boxSizing: 'border-box', margin: 'auto', position: 'relative', textAlign: 'left' }}>

                <div id='pm-change-etapa-view'>
                    <h3 style={{ marginBottom: 20, width: 'fit-content' }}>{objEtapa.denumire}</h3>

                    {/* <div style={{
                        marginTop: 13,
                        marginLeft: 10
                    }} >


                        <span style={{verticalAlign:'super'}}>Mod Vizionare</span>
                        <i onClick={() => { this.changeViewOption('think') }} style={{cursor:'pointer'}} className='material-icons'>emoji_objects</i>
                        <i onClick={() => { this.changeViewOption('gantt') }}  style={{cursor:'pointer'}} className='material-icons'>clear_all</i>
                        <i style={{color:'blue', cursor:'pointer'}} onClick={() => { this.changeViewOption('tabel') }} className='material-icons'>table_chart</i>

                 


                    </div> */}

                </div>


                {taskuriFilter.length === 0 &&
                    <div>
                        <span style={{ fontWeight: 400, fontSize: 12, verticalAlign: '-webkit-baseline-middle' }}>{this.dictionary.proiecte.noTaskInEtapa}</span>

                    </div>
                }

                <Grid style={{ marginBottom: 20, }} container>
                    <Grid style={{ padding: '0 10px 0 15px' }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                        <TabelTask
                            etapa={objEtapa}
                            showUserTag={this.props.showUserTag}
                            hideUserTag={this.props.hideUserTag}
                            headData={[this.dictionary.proiecte.taskName, this.dictionary.proiecte.dateStart, this.dictionary.proiecte.dateFinish]}
                            taskuri={taskuriFilter}
                            changeTask={this.props.changeTask}
                            updateTaskTitle={this.props.updateTaskTitle}
                            dataStartChange={this.props.dataStartChange}
                            dtDataStart={this.props.dtDataStart}
                            dataFinishChange={this.props.dataFinishChange}
                            dtDataFinish={this.props.dtDataFinish}
                            getTaskDates={this.props.getTaskDates}
                            isUtlizatorOpen={this.props.isUtlizatorOpen}
                            closeUtilizator={this.props.closeUtilizator}
                            listUsers={this.props.listUsers}
                            userClick={this.props.userClick}
                        />

                    </Grid>
                    <Grid style={{marginTop:20}} item xs={6} sm={6} md={6} lg={6} xl={6}>
                        {taskuriFilter.map((t, idxT) => {
                            // console.log('t :>> ', t);

                            return (
                                // <Hidden key={`taskuri${idxT}`} mdDown>
                                <div
                                    // onMouseEnter={() => { this.showEdit(`edit-task-etapa${t.id}`) }} 
                                    onClick={() => { this.props.goToTask(t) }}
                                    className='pm-task-etapa-integral' key={`taskuri${idxT}`}
                                    id={`taskuri${idxT}`}
                                    onMouseEnter={() => { this.props.showTag(t) }}
                                    onMouseLeave={() => { this.props.hideTag(t) }}
                                    style={{
                                        width: `${t.procent}%`,
                                        minWidth: 100,
                                        position: 'relative',
                                        marginTop: 20,
                                        marginLeft: `${t.marginLeft <= 80 ? t.marginLeft : 80}%`,
                                        backgroundColor: t.color,


                                        border: taskSelectatId === t.id ? `1px solid rgb(254	193	53	)` : '',

                                    }}>

                                    {/* <span className='pm-data-inceput-task'>{this.arataData(t.cand_data) + '-' + this.arataData(t.pana_cand_data)}</span> */}


                                    {t.procent_completare > 0 &&
                                        <div onClick={() => { this.props.goToTask(t) }} style={{
                                            backgroundColor: 'rgb(225 225 224)',
                                            position: 'absolute',
                                            width: (100 - t.procent_completare) + '%',
                                            height: '100%',
                                            right: 0,
                                            top: 0,

                                            borderTopRightRadius: 18,
                                            borderBottomRightRadius: 18
                                        }}>
                                            <div style={{ position: 'relative', width: '100%', height: '100%' }}>
                                                {t.subtaskuri_trecute > 0 && t.in_lucru &&
                                                    <i style={{
                                                        color: 'white',
                                                        fontSize: 12,
                                                        backgroundColor: 'red',
                                                        borderRadius: '50%',
                                                        padding: 1,
                                                        position: 'absolute',
                                                        bottom: 0,
                                                        left: -5
                                                    }} className='material-icons'>priority_high</i>

                                                }
                                            </div>
                                        </div>
                                    }








                                </div>



                            )
                        })}
                    </Grid>
                </Grid>





                <div>
                    <Button style={{ display: 'block', padding: 10, backgroundColor: 'rgb(24 166 59)', color: 'white', fontWeight: 500 }} onClick={() => { this.props.insertTask(this.props.objEtapaSelectata) }}  >
                        <i style={{verticalAlign:'sub'}} className='material-icons pm-round-button-text'>add</i>
                        {this.dictionary.proiecte.newTask}
                            </Button>
                </div>

                {/* {taskuriFilter.map((t, idxT) => {

                        return (
                            <Hidden key={`taskuri${idxT}`} smUp>
                                <div onMouseEnter={() => { this.showEdit(`edit-task-etapa${t.id}`) }} className='pm-task-etapa-integral' key={`taskuri${idxT}`} style={{
                                    width: `90%`,
                                    position: 'relative',
                                    marginTop: 10,
                                    marginBottom: 5,
                                    backgroundColor: t.color,
                                    height: 'fit-content'
                                }}>

                                    <span className='pm-data-inceput-task'>{this.arataData(t.cand_data) + '-' + this.arataData(t.pana_cand_data)}</span>
                                    <span onClick={() => { this.props.goToTask(t) }} style={{ backgroundColor: t.color }} className='pm-task-etapa-titlu'>{t.titlu}</span>
                                    <i onClick={() => { this.props.editTask(t, objEtapa) }} id={`edit-task-etapa${t.id}`} className='material-icons pm-edit-task'>create</i>


                                </div>

                                {listSubtaskuri.filter(st => st.id_task_parent === t.id).map((st, idxSt) => {
                                    return (
                                        <div className='pm-sub-task-integral' key={`subTaskuri${idxSt}`} style={{
                                            width: `90%`,
                                            position: 'relative',
                                            marginLeft: 20,
                                            marginBottom: 5,
                                            backgroundColor: st.color,
                                            height: 'fit-content'
                                        }}>
                                            <span onClick={() => { this.props.goToTask(st) }} style={{ backgroundColor: st.color }} className='pm-sub-task-titlu'>{st.titlu}</span>



                                            {listSubtaskuri.filter(sst => sst.id_task_parent === st.id).map((sst, idxSSt) => {
                                                return (
                                                    <div className='pm-sub-task-integral' key={`subTaskuri${idxSSt}`} style={{
                                                        width: `${sst.procent}%`,

                                                        bottom: sst.bottom,
                                                        left: `${sst.marginLeft}%`,
                                                        backgroundColor: sst.color
                                                    }}>
                                                        <span onClick={() => { this.props.goToTask(sst) }} style={{ backgroundColor: sst.color }} className='pm-sub-task-titlu'>{sst.titlu}</span>


                                                        {listSubtaskuri.filter(ssst => ssst.id_task_parent === sst.id).map((ssst, idxSSSt) => {
                                                            return (
                                                                <div className='pm-sub-task-integral' key={`subTaskuri${idxSSSt}`} style={{
                                                                    width: `${ssst.procent}%`,

                                                                    bottom: ssst.bottom,
                                                                    left: `${ssst.marginLeft}%`,
                                                                    backgroundColor: ssst.color
                                                                }}>
                                                                    <span onClick={() => { this.props.goToTask(ssst) }} style={{ backgroundColor: ssst.color }} className='pm-sub-task-titlu'>{ssst.titlu}</span>

                                                                    <div className='pm-task-etapa-line' style={{
                                                                        height: -ssst.bottom || 0,
                                                                        top: ssst.bottom || 0,
                                                                        transform: `skew(${ssst.degree}deg)`
                                                                    }}>

                                                                    </div>
                                                                </div>
                                                            )


                                                        })}
                                                    </div>
                                                )


                                            })}
                                        </div>
                                    )


                                })}






                            </Hidden>

                        )
                    })} */}

            </div>

        </div >


        return container

    }
    render() {
        return (
            <div style={{ width: '100%', position: 'relative', backgroundColor: 'white', padding: 20 }}>

                <Divider style={{ width: '100%' }} />

                <div style={{ display: this.props.displayHead === 1 ? 'none' : 'table' }} className='pm-proiect-integral-head'>

                    {!this.props.tableView &&
                        this.listHead()}

                    {this.props.tableView &&
                        <Grid container>
                            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>

                            </Grid>
                            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                                {this.listHead()}
                            </Grid>
                        </Grid>
                    }

                </div>




                <div style={{ display: 'flex', justifyContent: this.props.displayInapoi === 1 ? 'space-between' : 'flex-end', marginBottom: 20, padding: 15 }}>
                    {/* <Button style={{ display: this.props.displayInapoi === 1 ? 'inline-flex' : 'none' }} onClick={() => { this.props.changeView(true) }} className="pm-inapoi-button">
                        <i className='material-icons pm-round-button-text'>keyboard_arrow_left</i>
                        Inapoi la etape
                    </Button> */}

                    {/* <Button style={{ display: this.props.displayInsert === 1 ? 'none' : 'inline-flex' }} onClick={() => { this.props.insertTask(this.props.objEtapaSelectata) }} className="pm-adauga-button">
                        <i className='material-icons pm-round-button-text'>add</i>
                        Adauga Task
                    </Button> */}
                </div>

                {/* 
                <h3 className='pm-title'>{this.props.objProiectInfo[0].titlu}</h3> */}

                <div style={{ height: 'fit-content' }}>

                    {this.props.tableView &&
                        this.listBodyTable()
                    }
                    {this.props.ganttView &&
                        this.listBody()
                    }
                    {/* <svg style={{position:'absolute', width:'100vw', height:'50vh', left:0, top:0}}>
                {this.state.drawSvg}
              </svg> */}
                </div>





            </div>
        );
    }
}//end class


GanttEtapeMonthView.propType = {
    objProiectInfo: PropTypes.object,
    objEtapaSelectata: PropTypes.object,
    screenLimit: PropTypes.number,
    dictionary: PropTypes.object,
    listTaskuri: PropTypes.array,
    listSubtaskuri: PropTypes.array,
    editTask: PropTypes.func,
    goToTask: PropTypes.func,
    editEtapa: PropTypes.func,
    insertTask: PropTypes.func
}


